import { FC, useMemo } from 'react';

import { getTextWidth } from '../../../../../../helpers/utils/ui';


const ChartLabel: FC<any> = ({ chartFilter, isDisabled = false, chartType, currentMetrics, chartRef }) => {
    const labelName = useMemo(() => {
        if(chartType === 'pie' && Array.isArray(currentMetrics) && currentMetrics[0]?.label){
            return currentMetrics[0].label;
        }
        switch (chartFilter) {
            case 'reg':
                return 'Дата регистрации';
            case 'geo':
                return 'Дата рекламы';
            case 'app':
                return 'Дата рекламы';
            case 'order':
                return 'Дата заказа';
            case 'payment':
                return 'Дата платежа';
            case 'web':
                return 'Дата вебинара';
            case 'ad':
                return 'Дата рекламы';
            default:
                return '';
        }
    }, [ chartFilter, chartType, chartType === 'pie'? currentMetrics : null ]);
    const textWidth = useMemo(() =>  getTextWidth(labelName), [ labelName ]);
    return chartFilter && !isDisabled ? (
        <div className="universal-chart-label" style={{ width: '100%',height: '100%', margin: 'auto', paddingRight: chartType === 'pie' ? `calc(25.5% - ${textWidth/2}px)` : '', paddingTop: chartType === 'pie' ? '1.5%' : '' }}>
            <p style={{ marginBottom:0 }}>
                {labelName}
            </p>
        </div>
    ) : null;
};

export default ChartLabel;
